import type { ThemeDefinition } from './types';

export const editorialWarm: ThemeDefinition = {
  fontsUrl:
    'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Inter:wght@400;500;600&display=swap',
  variables: {
    '--report-font-display': "'Playfair Display', Georgia, serif",
    '--report-font-body': "'Inter', system-ui, sans-serif",
    '--report-bg': '#faf9f7',
    '--report-bg-surface': '#f5f3ef',
    '--report-text': '#2d2a24',
    '--report-text-secondary': '#5c5549',
    '--report-text-muted': '#9b9285',
    '--report-accent': '#b8492a',
    '--report-accent-dim': 'rgba(184, 73, 42, 0.1)',
    '--report-border': '#e4ddd3',
    '--report-border-strong': '#d1c8bb',
    '--report-stat-color': '#1a7a6d',
    '--report-stat-positive': '#1a7a6d',
    '--report-stat-negative': '#b8492a',
    '--report-callout-bg': '#f5f3ef',
    '--report-callout-border': '#9b7b2a',
    '--report-surface-hover': '#ede9e3',
    '--report-measure': '780px',
  },
};
